import type { JSX } from 'react';

import styled from 'styled-components';

import RequireIndicator from '../../RequireIndicator';

const Subtitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const Row = styled.span`
  display: flex;
  align-items: center;
  width: 100%;

  @media (min-width: 600px) {
    width: auto;
  }
`;

const Text = styled.p`
  color: var(--Text-text-primary, #101c16);
  font: var(--sprout-font-body1-bold);
  margin: 0;
  padding-right: 8px;
`;

const Note = styled.p`
  color: var(--Text-text-secondary, #707773);
  font: var(--sprout-font-body2);
  flex: 1 1 100%;
  margin: 0;

  @media (min-width: 600px) {
    flex: unset;
    width: auto;
  }
`;

interface RequiredSubtitleProps {
  text?: string;
  note?: string;
}

function RequiredSubtitle({
  text,
  note
}: RequiredSubtitleProps): JSX.Element {
  return (
    <Subtitle>
      <Row>
        <RequireIndicator />
        <Text>{text || ''}</Text>
      </Row>

      <Note>{note || ''}</Note>
    </Subtitle>
  );
}

export default RequiredSubtitle;

